module.exports = "<div class=\"layui-row\">\r\n    <div class=\"layui-col-md9\">\r\n        <input type=\"input\" lay-verify=\"{{verify}}\" lay-verType=\"tips\" name=\"{{fieldName}}\" class=\"layui-input select-search-input\" />\r\n    </div>\r\n    <div class=\"layui-col-md3\">\r\n        <img class=\"verifyImg\" data-bind=\"click: reloadVerifyCode, attr:{src:src}\"/>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/form/ImgVerify.html
// module id = 80
// module chunks = 0